import { render, staticRenderFns } from "./EditContactType.vue?vue&type=template&id=7a85a80f&lang=pug"
import script from "./EditContactType.vue?vue&type=script&lang=js"
export * from "./EditContactType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports